import './styles/theme.css';
import './styles/dashboard.css';
import './styles/app-shell.css';
import { mount } from 'svelte';
import App from './App.svelte';

const app = mount(App, { target: document.getElementById('app')! });
export default app;
